export let colorValues = [
	{
		"id": "white",
		"hex": "#d5d0d7",
		"label": "Polar White"
	},
	{
		"id": "light_stone",
		"hex": "#c9b6aa",
		"label": "Light Stone"
	},
	{
		"id": "ash_gray",
		"hex": "#aca1a1",
		"label": "Ash Gray"
	},
	{
		"id": "tan",
		"hex": "#b59480",
		"label": "Saddle Tan"
	},
	{
			"id": "sand",
		"hex": "#a08f83",
		"label": "Desert Sand"
	},
	{
		"id": "brown_stone",
		"hex": "#a99487",
		"label": "Brown Stone"
	},
	{
		"id": "light_brown",
		"hex": "#6f5b50",
		"label": "Light Brown"
	},
	{
		"id": "coco_brown",
		"hex": "#61443f",
		"label": "Coco Brown"
	},
	{
		"id": "old_town",
		"hex": "#9997a0",
		"label": "Old Town Gray"
	},
	{
		"id": "charcoal",
		"hex": "#635959",
		"label": "Charcoal Gray"
	},
	{
		"id": "burnished_slate",
		"hex": "#504541",
		"label": "Burnished Slate"
	},
	{
		"id": "dark_bronze",
		"hex": "#3a2f2a",
		"label": "Dark Bronze"
	},
	{
		"id": "crimson_red",
		"hex": "#9e282a",
		"label": "Crimson Red"
	},
	{
		"id": "rustic_red",
		"hex": "#874039",
		"label": "Rustic Red"
	},
	{
		"id": "apple_red",
		"hex": "#7b2e28",
		"label": "Apple Red"
	},
	{
		"id": "obrry",
		"hex": "#58353b",
		"label": "Berry"
	},
	{
		"id": "colony_green",
		"hex": "#72786e",
		"label": "Colony Green"
	},
	{
		"id": "evergreen",
		"hex": "#394e46",
		"label": "Evergreen"
	},
	{
		"id": "hawaiian_blue",
		"hex": "#496d83",
		"label": "Hawaiian Blue"
	},
	{
		"id": "gallery_blue",
		"hex": "#1e4a68",
		"label": "Gallery Blue"
	},
	{
		"id": "galvalume_plus",
		"hex": "#D0D6D6",
		"label": "Galvalume"
	},
	{
		"id": "ivory",
		"hex": "#e2cdbb",
		"label": "Ivory"
	},
	{
		"id": "metallic_copper",
		"hex": "#b58533",
		"label": "Copper Metallic"
	},
	{
		"id": "black",
		"hex": "#0e0f10",
		"label": "Black"
	}
];
